import { useState } from "react";
import { toast } from "sonner";
import { Pencil, Check, X, Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const NameCard = () => {
  const { user, refreshUser } = useAuth();
  const [editing, setEditing] = useState(false);
  const [name, setName] = useState(user.name);
  const [busy, setBusy] = useState(false);
  const trimmed = name.trim();

  const save = async (e) => {
    e.preventDefault();
    if (trimmed === user.name) return setEditing(false);
    setBusy(true);
    try {
      const { data } = await api.post("/auth/me/name", { name: trimmed });
      const fresh = await refreshUser();
      // Only confirm once the server really has the new name
      if (data?.name !== trimmed || fresh?.name !== trimmed) throw new Error("Your name didn't save — please try again");
      toast.success("Name updated");
      setEditing(false);
    } catch (err) {
      toast.error(errMsg(err, err.message || "Could not update your name"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mm-card p-4 mb-6" data-testid="name-card">
      <div className="text-xs text-mm-muted font-semibold uppercase tracking-wider">Your name</div>
      {editing ? (
        <form onSubmit={save} className="flex gap-2 mt-2">
          <input className="mm-input" autoFocus maxLength={40} value={name} onChange={(e) => setName(e.target.value)} data-testid="name-input" />
          <button className="mm-btn !px-4" disabled={busy || !trimmed} data-testid="name-save" aria-label="Save name">{busy ? <Loader2 size={16} className="animate-spin" /> : <Check size={16} />}</button>
          <button type="button" className="mm-btn-ghost !px-4" onClick={() => { setName(user.name); setEditing(false); }} data-testid="name-cancel" aria-label="Cancel"><X size={16} /></button>
        </form>
      ) : (
        <div className="flex items-center justify-between mt-1">
          <span className="font-display text-xl font-bold" data-testid="name-display">{user.name}</span>
          <button className="p-2 rounded-full hover:bg-mm-soft" onClick={() => { setName(user.name); setEditing(true); }} data-testid="name-edit" aria-label="Edit name"><Pencil size={16} /></button>
        </div>
      )}
    </div>
  );
};
